import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'
import ProductCard from './../block/ProductCardCart'
import ProductCardGift from './../block/ProductCardGiftCart'
import ExtraCard from './../block/ExtraCardCart'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      promocode: ``
    }
  }

  open = ( e, elm ) => {
    e.preventDefault();
    const { openProductWin } = this.props

    openProductWin( elm?.id )
  }

  calculateBonus( totalPrice, percent ) {
    if (!totalPrice || !percent) return 0;
    return Math.floor(totalPrice / 100 * percent);
  }

  setPromocode( promocode ) {
    this.setState({
      promocode: promocode
    })
  }

  componentDidMount() {
    const { cart } = this.props
    this.setState({
      promocode: cart?.promocode || ``
    })
  }

  render() {
    const { data, user, cart, change, changeExtra, assets_path, sendPromocode, openProductWin } = this.props,
    { promocode } = this.state

    return (
      <div
        className='bg-cover bg-center bg-no-repeat'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container font-manrope tracking-tight min-h-dvh flex flex-col overflow-x-hidden'>
          <SimpleHeader
            title={`Корзина`}
            user={user}
            lk_link={data?.lk_link}
          />
          <div className='rounded-[25px] bg-white px-[10px] pt-[15px] mt-[8px] mb-[auto] pb-[15px]'>
            {cart?.total_items > 0 ?
              <>
                {cart?.items.map(( elm, k ) => (
                  <ProductCard
                    key={k}
                    elm={elm}
                    change={change}
                    open={openProductWin}
                  />
                ))}
                {cart?.gifts.map(( elm, k ) => (
                  <ProductCardGift
                    key={k}
                    elm={elm}
                  />
                ))}
                {cart?.extras.map(( elm, k ) => (
                  <ExtraCard
                    key={k}
                    elm={elm}
                    change={changeExtra}
                  />
                ))}
              </>
            :
              <div className='text-center'>Добавьте блюда в корзину!</div>
            }
          </div>
          <div className='text-center text-[22px] text-black font-semibold mt-[15px]'>Может что-то еще?</div>
          <div className='text-center text-[#00000099] font-normal text-[14px] mb-[15px]'>Добавьте к заказу, чтобы стало  вкуснее</div>
          <div className='w-[calc(100%+10px)] flex gap-[5px] pb-[5px] overflow-x-auto scroll-bar-custom mb-[15px] min-h-[215px]'>
            {data?.recomended.map((elm, k) => (
              <div className='w-[138px] p-[10px] bg-white rounded-[25px] relative flex-none' key={k}>
                <img 
                  className='w-[100%] h-[auto] mx-auto' 
                  src={elm?.image} 
                  alt={elm?.pagetitle} 
                  width="107"
                  height="90"
                />
                <div className='text-[14px] text-[#00000099] line-clamp-2'>{elm?.razdel}</div>
                <a
                  className='text-black block hover:text-black text-[16px] font-medium mb-[10px] after:absolute after:inset-0 z-0'
                  onClick={( e ) => this.open( e, elm )}
                  href={elm?.href}
                >
                  <span className='line-clamp-1'>{elm?.pagetitle}</span>
                </a>
                <div className='flex items-center justify-between gap-[5px] whitespace-nowrap'>
                  <div className='bg-[#5A91FF] rounded-full h-[30px] px-[20px] flex items-center justify-center'>
                    <div className='text-white text-[16px] font-normal'>{elm?.price} ₽</div>
                  </div>
                  <div className='text-right'>
                    <div className='text-[#00000099] text-[14px]'>Вес</div>
                    <div className='text-black text-[14px]'>{elm?.measure}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className='flex gap-[10px] mb-[20px] bg-white rounded-[50px] h-[40px] items-center p-[5px]'>
            <input value={promocode} onChange={( e ) => this.setPromocode( e.target.value )} className='border-0 text-[16px] text-[#00000099] ml-[10px] flex-1' placeholder='Ввести промокод' name='promocode' />
            <div onClick={() => sendPromocode( promocode )} className='bg-[#F6F6F6] rounded-[50px] flex items-center justify-center w-[30px] h-[30px] cursor-pointer'>
              <svg xmlns="http://www.w3.org/2000/svg" width={15} height={16} fill="none">
                <path
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.239 5.925 4.863 1.517C2.875.469.714 2.587 1.719 4.595l1.17 2.342c.326.65.326 1.416 0 2.067l-1.17 2.341c-1.005 2.01 1.156 4.12 3.144 3.08l8.376-4.41c1.648-.867 1.648-3.223 0-4.09Z"
                />
              </svg>
            </div>
          </div>
          <div className='bg-white rounded-t-[18px] w-[calc(100%+20px)] ml-[-10px] p-[15px]'>
            <div className='flex gap-[5px] items-center mb-[10px] mt-[5px]'>
              <div className='text-[14px] text-[#00000099] font-medium'>{cart?.total_items} товара</div>
              <div className='flex-1 h-[0px] w-[100%]' style={{ borderTop: `1px #0000001a dashed` }} />
              <div className='text-[14px] text-[#00000099] font-medium'>
                {cart?.total_price != cart?.total_discount_price ? (
                  <>
                    <span className="line-through">{cart?.total_price}</span>
                    {' '}
                    <span>{cart?.total_discount_price} ₽</span>
                  </>
                ) : (
                  <span>{cart?.total_discount_price} ₽</span>
                )}
              </div>
            </div>
            <div className='flex gap-[5px] items-center mb-[10px]'>
              <div className='text-[14px] text-[#00000099] font-medium'>Оки-коины</div>
              <div className='flex-1 h-[0px] w-[100%]' style={{ borderTop: `1px #0000001a dashed` }} />
              <div className='text-[14px] text-[#00000099] font-medium flex items-center gap-[2px]'>
                <div>+{this.calculateBonus(cart?.total_price, user?.rang_percent)}</div>
                <svg xmlns="http://www.w3.org/2000/svg" width={10} height={13} fill="none">
                  <path
                    fill="#5A91FF"
                    d="M5 1.55c2.7 0 4.89 2.217 4.89 4.95 0 2.734-2.19 4.95-4.89 4.95C2.3 11.45.111 9.235.111 6.5.111 3.767 2.3 1.55 5 1.55ZM3.002 5.53c-.757 0-1.38.607-1.38 1.355 0 .749.623 1.356 1.38 1.356a1.354 1.354 0 1 0 0-2.71Zm2.027-.74a.418.418 0 0 0-.418.418v2.614a.419.419 0 1 0 .837 0v-.683l.764.958a.382.382 0 0 0 .61-.458l-.58-.817.514-.674a.332.332 0 1 0-.53-.401L5.449 6.78V5.208a.419.419 0 0 0-.419-.418Zm2.553.825a.38.38 0 0 0-.377.382V7.86c0 .21.17.38.377.38.208 0 .376-.17.376-.38V5.997a.38.38 0 0 0-.376-.382Zm-4.58.635c.325 0 .585.284.585.635 0 .351-.26.636-.585.636-.326 0-.606-.284-.606-.636 0-.351.28-.635.606-.635Zm5.156-1.926c-.183-.351-.442.017-.557.225-.117-.208-.384-.576-.568-.225-.183.352.292.853.563 1.068.27-.215.746-.716.562-1.068Z"
                  />
                  <path
                    stroke="#5A91FF"
                    strokeLinecap="round"
                    strokeWidth={0.9}
                    d="M5 1.55V1M5 12v-.55"
                  />
                </svg>
              </div>
            </div>
            {user?.delivery_type == 'delivery' &&
              <div className='flex gap-[5px] items-center mb-[15px]'>
                <div className='text-[14px] text-[#00000099] font-medium'>Доставка</div>
                <div className='flex-1 h-[0px] w-[100%]' style={{ borderTop: `1px #0000001a dashed` }} />
                <div className='text-[14px] text-[#00000099] font-medium'>
                  {cart?.total_price >= user?.location?.sum_for_free ? `0` : user?.location?.delivery_price} ₽
                  {user?.location?.time != `` && <> за <span className='text-black'>{user?.location?.time} мин</span></>}
                </div>
              </div>
            }
            {cart?.promocode != '' &&
              <div className='flex gap-[5px] items-center mb-[15px]'>
                <div className='text-[14px] text-[#00000099] font-medium'>Промокод {cart?.promocode}</div>
                <div className='flex-1 h-[0px] w-[100%]' style={{ borderTop: `1px #0000001a dashed` }} />
                {cart?.total_price != cart?.total_discount_price ?
                  <div className='text-[14px] text-[#00000099] font-medium'>
                    скидка {cart?.total_price - cart?.total_discount_price} ₽
                  </div>
                :
                  <div></div>
                }
              </div>
            }
            {cart?.total_items > 0 &&
              <a
                href={data?.oformlenie_link}
                onClick={(e) => {
                  if (!cart?.promocode && promocode) {
                    e.preventDefault();
                    sendPromocode(promocode).then(() => {
                      window.location.href = data?.oformlenie_link;
                    });
                  }
                }}
                className="w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#5A91FF] text-white flex items-center justify-between gap-2 no-underline"
              >
                <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF40] flex items-center justify-center'>
                  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
                    <path
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      d="M1.668 1.667h1.45c.9 0 1.608.775 1.533 1.666l-.691 8.3a2.33 2.33 0 0 0 2.325 2.525h8.875c1.2 0 2.25-.983 2.341-2.175l.45-6.25c.1-1.383-.95-2.508-2.341-2.508H4.85M13.542 18.333a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM6.874 18.333a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM7.5 6.667h10"
                    />
                  </svg>
                </div>
                К оформлению заказа
                <div className='w-[30px] h-[30px]'></div>
              </a>
            }
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  data: PropTypes.object,
  protocol: PropTypes.string,
  user: PropTypes.object,
  cart: PropTypes.object,
  change: PropTypes.func,
  changeExtra: PropTypes.func,
  openProductWin: PropTypes.func,
  sendPromocode: PropTypes.func
}

export default Main